import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../../redux/slice/system";
import { ContractAPI } from "../../../../axios/api";
import {
  useAbortedEffect,
  useSearch,
  useTable,
  usePop,
  useConfirm,
} from "../../../../components/hooks";

import ModuleTitle from "../../../../components/common/title";
import ModulePopSettingContractForm from "./popForm";
import { setPageSetting } from "../../../../service/common";
import { system_table } from "../../../../service/system";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function MemberSettingContract() {
  const dispatch = useDispatch();
  const [reload, setReload] = useState({ list: false });
  const {
    setTbData,
    tbTotalRecords,
    setTbTotalRecords,
    setTbFirstIndex,
    setTbRows,
    setTbColumns,
    renderTable,
    setPageAction,
  } = useTable();
  // 篩選條件
  const defaultFilter = {
      page: 1,
      size: system_table.size,
    },
    pagePath = "/setting/contract";
  const {
    filterData,
    setFilterData,
    search,
    setSearch,
    changeFilter,
    renderSearchWrap,
  } = useSearch({
    defaultFilter,
    pagePath: [pagePath],
    tbSetting: { setTbFirstIndex, setTbRows },
    reloadAction: () => setReload((state) => ({ ...state, list: true })),
  });
  const { isPop, popOption, openPop, closePop, renderDialog } = usePop([
    {
      key: "form",
      title: (props) => `${props?.data?.id ? "查看" : "提問"}`,
      isOpen: false,
    },
  ]);
  const { confirmOption, setConfirmOption, renderConfirm } = useConfirm();

  useEffect(() => {
    const action = ({ startIndex, rows }) => {
      let temp = {
        ...search,
        page: Math.floor(startIndex / rows) + 1,
        size: rows,
      };
      setFilterData(temp);
      setSearch(temp);
    };
    setPageAction(
      () =>
        ({ startIndex, rows }) =>
          action({ startIndex, rows })
    );
  }, [search]);

  // 取得列表資料
  useAbortedEffect(
    (signal) => {
      if (!reload.list) return;

      dispatch(setProgress(true));

      setPageSetting({ params: search, page: pagePath });

      let params = {
        ...search,
      };

      ContractAPI.getMyQuestionAndAnswerMemberList({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, total, message } = result;

        if (Response === 1) {
          data = data.map((item, index) => ({
            ...item,
            sbp: 20 * index,
          }));
          setTbData(data);
          setTbTotalRecords(total);
          setReload((state) => ({
            ...state,
            list: false,
          }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  useEffect(() => {
    const renderBtnAction = (data) => (
      <>
        <Button
          className={classNames("p-button-sm", {
            "p-button-secondary": !data.answer,
          })}
          type="button"
          label={data.answer ? "已回覆" : "已提問"}
          onClick={() => openPop({ type: "form", data })}
        />
        {/* <Button
          id={`button_delete_${data.id}`}
          className="p-button-danger p-button-sm ml-2"
          type="button"
          label="刪除"
          onClick={() =>
            setConfirmOption({
              setting: {
                target: document.getElementById(`button_delete_${data.id}`),
                message: "確認是否刪除?",
                icon: "pi pi-exclamation-triangle",
                visible: !confirmOption.setting.visible,
                acceptLabel: "是",
                rejectLabel: "否",
                accept: () => deleteAction({ data }),
                reject: () => null,
              },
              reOpen: confirmOption.setting.visible,
            })
          }
        /> */}
      </>
    );

    setTbColumns([
      {
        field: "question",
        header: "問題",
        className: "flex-grow-1 w-10rem white-space-prewrap",
      },
      {
        field: "createdatetime",
        header: "提問時間",
        className: "flex-grow-1 w-10rem white-space-prewrap",
      },
      {
        field: "updatedatetime",
        header: "回覆時間",
        className: "flex-grow-1 w-10rem white-space-prewrap",
        body: (data) => <>{data.answer ? data.updatedatetime : ""}</>,
      },
      {
        field: "id",
        header: "回覆",
        className: "w-6rem froze-right",
        alignFrozen: "right",
        frozen: true,
        body: (data) => renderBtnAction(data),
      },
    ]);
  }, [pagePath]);

  const deleteAction = ({ data }) => {
    dispatch(setProgress(true));

    let jsonData = { data: [data.id] };

    ContractAPI.deleteQuestionAndAnswerMember({ data: jsonData }).then(
      (result) => {
        let { Response } = result;

        if (Response === 1) {
          dispatch(
            setToast({
              severity: "success",
              summary: "成功刪除",
              detail: "",
            })
          );
          setReload((state) => ({
            ...state,
            list: true,
          }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: "刪除失敗",
              detail: "",
            })
          );
          dispatch(setProgress(false));
        }
      }
    );
  };

  return (
    <>
      {renderConfirm}

      <ModuleTitle data={{ title: "我要提問" }} />

      <div className="flex">
        <Button
          className="p-button-warning w-auto text-xl ml-auto px-4"
          type="button"
          label="提問"
          onClick={() => openPop({ type: "form", data: null })}
        />
      </div>

      {renderTable({
        className: "mt-2",
        isLazy: false,
        options: {
          scrollable: true,
          scrollDirection: "both",
        },
      })}

      {renderDialog({
        className: "w-11 md:w-10 lg:w-8 max-w-40rem",
        children: (
          <>
            {isPop.form?.isOpen && (
              <ModulePopSettingContractForm
                prePopOption={popOption}
                closePrePop={closePop}
                setPreReload={setReload}
              />
            )}
          </>
        ),
      })}
    </>
  );
}
